<template>
  <div>
    <el-descriptions border size="small" :column="1" class="mt-1">
      <el-descriptions-item
        :label="$l('form_label_fabricScmName') || '店铺名称'"
        :labelStyle="{ width: '20px', 'font-weight': '600' }"
        :contentStyle="{ width: '200px', 'font-weight': '700' }"
      >
        {{ formData.resFabricScmName || '' }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('form_label_fabricScmAddress') || '店铺地址'"
        :labelStyle="{ width: '20px', 'font-weight': '600' }"
        :contentStyle="{ width: '200px', 'font-weight': '700' }"
      >
        {{ formData.resFabricScmAddress || '' }}
      </el-descriptions-item>
    </el-descriptions>
    <el-card
      class="mt-3"
      style="width:859px"
      :body-style="{ padding: '0 0 0 0' }"
      shadow="never"
    >
      <div
        style="display: flex;justify-content: space-between;flex-wrap: wrap;"
      >
        <div style="width:146px">
          <div style="width:130px; height:130px" class="mr-2 ml-2">
            <el-image
              :src="
                formData.thumbImageUrl
                  ? $osscdn(formData.thumbImageUrl)
                  : '/image/static/img/nopic.jpg'
              "
              style="width:130px; height:130px"
              @click.stop="onImagePreview(0)"
            >
              <div slot="error" class="image-slot">
                <img
                  src="/image/static/img/nopic.jpg"
                  style="width: 130px; height: 130px"
                />
              </div>
            </el-image>

            <el-upload
              id="uploader"
              ref="uploader"
              action="#"
              :show-file-list="false"
              :auto-upload="false"
              :on-change="uploadChange"
              accept=".jpeg,.jpg,.png,.gif"
            >
              <b-button
                style="width: 130px"
                v-if="!disabled"
                size="sm"
                variant="outline-primary"
                >{{ $l('form_label_image_maintenance') || '图片维护' }}
              </b-button>
            </el-upload>
          </div>
        </div>
        <div style="width:703px">
          <el-descriptions
            border
            size="small"
            :column="2"
            :labelStyle="{ width: '85px', 'font-weight': '600' }"
            :contentStyle="{
              width: '266px',
              'font-weight': '700',
              padding: '4px 5px',
            }"
          >
            <el-descriptions-item
              :label="$l('form_label_fty_no') || '厂家编号'"
            >
              <el-input
                v-model="formData.ftyNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
                maxlength="200"
                size="small"
                :disabled="disabled"
              >
              </el-input>
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_fabric_no') || '面料编号'"
            >
              {{ formData.resFabricRecordNo || '' }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_fabric_name') || '面料名称'"
            >
              <dict-select
                v-model="formData.fabricDescriptionArray"
                url="/digitalCenter/master/fabric/attributes/attributesSelect"
                :body="{ fabricAttrTypeEn: 'Fabric Description' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
                multiple
                :disabled="disabled"
                :options="{ label: 'label', value: 'this' }"
              ></dict-select>
            </el-descriptions-item>
            <el-descriptions-item :label="$l('form_label_pattern') || '花型'">
              <dict-select
                v-model="formData.patternArray"
                url="/digitalCenter/master/fabric/attributes/attributesSelect"
                :body="{ fabricAttrTypeEn: 'Pattern' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
                multiple
                :disabled="disabled"
                :options="{ label: 'label', value: 'this' }"
              ></dict-select>
            </el-descriptions-item>
            <el-descriptions-item :label="$l('table_label_techName') || '工艺'">
              <dict-select
                v-model="formData.techniqueArray"
                url="/digitalCenter/master/fabric/attributes/attributesSelect"
                :body="{ fabricAttrTypeEn: 'Technique' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
                multiple
                :disabled="disabled"
                :options="{ label: 'label', value: 'this' }"
              ></dict-select>
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('INDEX.choose_fabric_function') || '功能'"
            >
              <dict-select
                v-model="formData.functionArray"
                url="/digitalCenter/master/fabric/attributes/attributesSelect"
                :body="{ fabricAttrTypeEn: 'Function' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
                multiple
                :disabled="disabled"
                :options="{ label: 'label', value: 'this' }"
              ></dict-select>
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_fabric_weight') || '克重'"
            >
              <el-row :gutter="10">
                <el-col :span="16">
                  <el-input-number
                    controls-position="right"
                    style="width: 100%"
                    size="small"
                    :min="0"
                    :step="0.01"
                    :precision="2"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    :disabled="disabled"
                    v-model="formData.fabricWeight"
                  ></el-input-number>
                </el-col>
                <el-col :span="8">
                  <dict-select
                    v-model="formData.fabricWeightUnit"
                    url="/digitalCenter/common/dict/biz"
                    :body="{ dictType: 'fabricWeightUnit' }"
                    :disabled="disabled"
                    :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                    size="small"
                    filterable
                    clearable
                  ></dict-select>
                </el-col>
              </el-row>
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_fabric_wid') || '门幅'"
            >
              <el-row :gutter="10">
                <el-col :span="16">
                  <el-input-number
                    controls-position="right"
                    style="width: 100%"
                    size="small"
                    :min="0"
                    :step="0.01"
                    :precision="2"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    :disabled="disabled"
                    v-model="formData.fabricWid"
                  ></el-input-number>
                </el-col>
                <el-col :span="8">
                  <dict-select
                    v-model="formData.widUnit"
                    url="/digitalCenter/common/dict/biz"
                    :body="{ dictType: 'widUnit' }"
                    :disabled="disabled"
                    :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                    size="small"
                    filterable
                    clearable
                  ></dict-select>
                </el-col>
              </el-row>
            </el-descriptions-item>
            <el-descriptions-item :label="$l('form_label_moq') || '起定量'">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-input-number
                    controls-position="right"
                    style="width: 100%"
                    size="small"
                    :min="0"
                    :step="0.01"
                    :precision="2"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    :disabled="disabled"
                    v-model="formData.moq"
                  ></el-input-number>
                </el-col>
              </el-row>
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_unitPrice') || '面料单价'"
            >
              <el-row :gutter="10">
                <el-col :span="16">
                  <el-input-number
                    controls-position="right"
                    style="width: 100%"
                    size="small"
                    :min="0"
                    :step="0.01"
                    :precision="2"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    :disabled="disabled"
                    v-model="formData.unitPrice"
                  ></el-input-number>
                </el-col>
                <el-col :span="8">
                  <dict-select
                    v-model="formData.fabricUnit"
                    url="/digitalCenter/common/dict/biz"
                    :body="{ dictType: 'fabricYarnUnit' }"
                    :disabled="disabled"
                    :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                    size="small"
                    filterable
                    clearable
                  ></dict-select>
                </el-col>
              </el-row>
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_fabric_content') || '成分'"
            >
              <FabricContentInput
                :fabricContent.sync="formData.fabricContent"
                :fabricContentEn.sync="formData.fabricContentEn"
                :disabled="disabled"
                size="small"
              />
            </el-descriptions-item>
          </el-descriptions>

          <el-descriptions
            border
            size="small"
            :column="2"
            :labelStyle="{ width: '85px', 'font-weight': '600' }"
            :contentStyle="{
              width: '266px',
              'font-weight': '700',
              padding: '4px 5px',
            }"
          >
            <el-descriptions-item :label="$l('form_label_describe') || '描述'">
              <el-input
                type="textarea"
                v-model="formData.description"
                clearable
                :rows="3"
                size="small"
                :disabled="disabled"
              >
              </el-input>
            </el-descriptions-item>
          </el-descriptions>

          <div
            style="width:703px;height:154px;overflow-y: scroll;"
            v-if="voiceList && voiceList.length > 0"
          >
            <div
              class="voice_border"
              v-for="(voice, ice) in voiceList"
              :key="`${ice}-${voice.voiceFileCode}`"
            >
              <Audio
                :ref="'voice_' + voice.voiceFileCode"
                :audioData="{
                  url: voice.voiceFileUrl,
                }"
                :id="ice"
                @play="changeOtherPlay"
                :key="`${ice}-${voice.voiceFileCode}`"
              ></Audio>

              <div style="height:30px;margin-top:4px;" v-if="!disabled">
                <i class="el-icon-delete tool-del" @click="del(voice)"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-card>

    <FabricInfoImage
      ref="fabricInfoImage"
      :disabled="disabled"
      :resFabricInfoCode="resFabricInfoCode"
      :resFabricScmCode="resFabricScmCode"
    />
    <div class="d-flex justify-content-end mt-2 mb-2" v-if="!disabled">
      <el-button type="primary" size="small" @click="save()">
        {{ $l('INDEX.btn_save') || '保存' }}
      </el-button>
    </div>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>

    <div v-show="false" class="fabricImagesViewer" v-viewer="{ movable: true }">
      <img
        v-for="item in listImageUrl"
        :src="item || '/image/static/img/nopic.jpg'"
        :key="item"
      />
    </div>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import FabricInfoImage from '../fabric-info-image'
import Audio from './audio/audioComponent'
import FabricContentInput from '@/views/digital/components/fabric-content-input'
export default {
  mixins: [EditLoading],
  components: { FabricInfoImage, Audio, FabricContentInput },
  props: {
    disabled: { type: Boolean, default: false },
    isCopy: { type: Boolean, default: false },
    resFabricInfoCode: { type: String, default: '' },
    resFabricScmCode: { type: String, default: '' },
  },
  data() {
    return {
      backDialogVisible: false,
      loading: false,
      formData: {
        resFabricInfoCode: '',
        resFabricScmCode: '',
        resFabricRecordCode: '',
        fabricCode: '',
        fabricName: '',
        fabricNameEn: '',
        fabricAttributes: '',
        ftyNo: '',
        fabricContent: '',
        fabricContentEn: '',
        fabricWid: '',
        widUnit: '',
        fabricWeight: '',
        fabricWeightUnit: '',
        unitPrice: '',
        fabricUnit: '',
        imageCode: '',
        imageUrl: '',
        thumbImageCode: '',
        thumbImageUrl: '',
      },
      listImage: [],
      voiceList: [],
      imageVisible: true,
      rules: {},
    }
  },
  mounted() {
    this.loadData()
  },
  computed: {
    isEmpty() {
      return !this.listImage || !this.listImage.length
    },
    listImageUrl() {
      return this.isEmpty ? [] : this.listImage
    },
  },
  methods: {
    async loadData() {
      if (!this.resFabricInfoCode) return
      this.getVoiceList()
      this.loading = true
      const res = await this.$api
        .resFabricInfoDetailApi({ resFabricInfoCode: this.resFabricInfoCode })
        .catch(() => {})
      this.loading = false
      const data = res.body || {}
      const fabricWeightUnit = data.fabricWeightUnit || 'gsm'
      const widUnit = data.widUnit || 'cm'
      this.formData = { ...data, fabricWeightUnit, widUnit }
      this.listImage = [this.formData.imageUrl]
    },
    getVoiceList() {
      this.loading = true
      this.$api
        .resFabricVoiceListApi({
          resFabricInfoCode: this.resFabricInfoCode,
          isLocalImg: 'N',
        })
        .then((res) => {
          this.loading = false
          this.voiceList = res.body.data || []
        })
        .catch(() => {
          this.loading = false
        })
    },

    async save() {
      const fabricColorNameList = await this.$refs.fabricInfoImage.getTableData()

      const params = {
        resFabricInfoCode: this.resFabricInfoCode,
        ...this.formData,
        fabricColorNameList,
      }
      this.loadingOpen()
      const res = await this.$api.resFabricInfoSaveApi(params).catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      this.close()
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
    onImagePreview(index) {
      if (this.isEmpty) return
      const viewer = this.$el.querySelector('.fabricImagesViewer').$viewer
      viewer.view(index)
      viewer.show()
    },
    async uploadChange(file) {
      if (!file) {
        this.$message.warning(
          this.$l('pe_select_upload_image') || '请选择您需要上传的图片！'
        )
        return
      }

      this.loadingOpen()
      const image = await this.uploadImages(file)
      if (image == null) {
        this.$message.error(
          this.$l('INDEX.uploader_label_status_error') || '上传失败'
        )
        this.loadingClose()
        return
      }
      const params = { resFabricInfoCode: this.resFabricInfoCode, ...image }
      const res = await this.$api
        .resFabricInfoUpdateImageApi(params)
        .catch(() => {
          this.loadingClose()
          return null
        })
      this.loadingClose()
      const { status } = res
      if (status !== 200) {
        this.$message.error(
          this.$l('INDEX.uploader_label_status_error') || '上传失败'
        )
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.uploader_label_status_success') || '上传成功',
        type: 'success',
      })
      this.loadData()
    },
    uploadImages(file) {
      if (!file) {
        return Promise.resolve({})
      }
      const uploadTask = this.$api
        .SYS_UPLOAD(file.raw)
        .then((res) => ({
          imageCode: res.body.fileId,
          imageUrl: res.body.url,
        }))
        .catch(() => {
          this.loadingClose()
          return null
        })
      return uploadTask
    },
    changeOtherPlay(index) {
      this.voiceList.forEach((item, i) => {
        if (i != index) {
          this.$refs['voice_' + item.voiceFileCode] &&
            this.$refs['voice_' + item.voiceFileCode][0].pauseAudio()
        }
      })
    },
    del(voice) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .resFabricVoiceDelApi({ fabricVoiceCode: voice.fabricVoiceCode })
          .then(() => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.getVoiceList()
          })
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  border-left: 3px solid $color-success;
  height: 26px;
  margin: 0;
  padding: 0;
}

.image-wrapper {
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  .default-icon {
    position: absolute;
    z-index: 999;
    right: 0;
    display: flex;
    align-items: flex-start;
    color: #20c997;
  }
}
.image-wrapper img {
  max-width: 100%;
  max-height: 100%;
}

.voice_border {
  border: 1px solid #dcdfe6;
  border-bottom: 1px solid white;
  background-color: #f1f3f4;
  display: flex;
}
.tool-del {
  width: 30px;
  height: 30px;
  font-size: 18px;
  line-height: 30px !important;
  cursor: pointer;
}

::v-deep {
  .el-form {
    > div:first-child {
      border-top: 1px solid #ebeef5;
    }
    > div {
      border: 1px solid #ebeef5;
      border-top: none;

      > .el-form-item {
        margin: 0 !important;
        position: relative;

        .el-form-item__label {
          color: #909399;
          background: #fafafa;
          box-sizing: border-box;
          text-align: left;
          font-weight: 400;
          line-height: 1.5;
          padding: 8px 10px;
          border-right: 1px solid #ebeef5;
          font-size: 12px !important;
          position: absolute;
          bottom: 0;
          top: 0;
          display: flex;
          align-items: center;
        }

        .el-form-item__content {
          padding: 0 10px;
          box-sizing: border-box;
          text-align: left;
          font-weight: 400;
          line-height: 1.5;
          color: #606266;
          font-size: 12px !important;

          > div {
            margin: 3.2px 0;
          }
        }
      }
    }
  }
}
</style>
